import { Box, Divider, Grid } from '@mui/material';
import { WsButton } from 'wisestep-base';

import { campaignHeaderHelper } from '../../../utils';
import {
  CampaignHeader,
  EmailCountHeader,
  EmailSectionHeader,
  SectionHeaders,
} from '../campaignHeader';
import { PromptHeader } from '../promptHeaderMenu';

export const EmailCampaign = () => (
  <Grid display="flex" flexDirection="column" rowGap={1.5} columnSpacing={1}>
    <EmailCountHeader
      name={'totalEmails'}
      title={campaignHeaderHelper['totalEmails'].header}
      subTitle={campaignHeaderHelper['totalEmails'].subHeader}
    />
    <Divider />
    <CampaignHeader name="aiReplyEnabled">
      <SectionHeaders
        title={campaignHeaderHelper['aiReplyEnabled'].header}
        subTitle={campaignHeaderHelper['aiReplyEnabled'].subHeader}
      />
    </CampaignHeader>
    <PromptHeader name="emailReplyPrompts" />
    <EmailSectionHeader
      name={'manualReply'}
      sectionHeader={campaignHeaderHelper['manualReply'].header}
      sectionSubHeader={campaignHeaderHelper['manualReply'].subHeader}
      emailType={'manualEmail'}
    />
    <Divider />
    <EmailSectionHeader
      name={'callBackRequest'}
      sectionHeader={campaignHeaderHelper['callBackRequest'].header}
      sectionSubHeader={campaignHeaderHelper['callBackRequest'].subHeader}
      emailType={'callbackEmail'}
    />
    <Box display="flex" justifyContent="flex-end" columnGap={2}>
      <WsButton variant="outlined" type="reset">
        Cancel
      </WsButton>
      <WsButton type="submit">Save</WsButton>
    </Box>
  </Grid>
);
